// Static seat layout for the Dubai A3 Office.
// Seat assignments themselves (which user sits where) are stored server-side
// via the floor_plan_seats API - this file only describes the physical layout.
// Seat keys are prefixed with "da3" so they never collide with other floors.

import { seatBlock } from './seatLayout';

// Left column: single 6x2 block (12 seats) - one merged grid, matching the
// room's physical layout.
export const leftGroups = [
    seatBlock('da3l', 1, 6, 2),
];

// Single seat sitting above the right-hand column
export const topSeat = { key: 'da3-top', label: 'DA3-TOP' };

// Right column: four stacked 2x1 blocks (2 seats each), running down the
// right edge of the room below the top seat.
export const rightGroups = [
    seatBlock('da3r', 1, 1, 1),
    seatBlock('da3r', 2, 1, 1),
    seatBlock('da3r', 3, 1, 1),
    seatBlock('da3r', 4, 1, 1),
];

// Roughly locates a seat key within the layout so unit bubbles can be placed
// on the left or right rail of the Dubai A3 tab.
export function parseDubaiA3SeatKey(seatKey) {
    const [prefix, group] = seatKey.split('-');
    const groupIndex = Number(group) || 0;
    if (prefix === 'da3l') return { side: 'left', groupIndex, groupKey: `${prefix}-${groupIndex}` };
    if (prefix === 'da3r') return { side: 'right', groupIndex, groupKey: `${prefix}-${groupIndex}` };
    return { side: 'right', groupIndex: 0, groupKey: 'da3-top' };
}

export const allDubaiA3Seats = [
    ...leftGroups.flat(2),
    topSeat,
    ...rightGroups.flat(2),
];
